/**
 * Colores oficiales de estado de venta (de dbo.Estados.ColorHEX). Se usan para
 * pintar el fondo de las celdas en Avance y Venta/Indirectos según el estado que
 * la obra tenía ese mes. Consistentes con el resto de sistemas de Adelante.
 */
const COLOR_HEX: Record<string, string> = {
  Formalizado: '#8F77A6', // morado
  Disponible: '#5CB85C', // verde
  Reservado: '#579CEE', // azul
  Entregado: '#F2B035', // naranja
};

/** Color de fondo (tenue) para la celda según el estado. '' si no hay estado. */
export function colorFondoEstado(estado: string | null | undefined): string {
  if (!estado) return '';
  const hex = COLOR_HEX[estado];
  if (!hex) return '';
  // Fondo tenue (alpha bajo) para no tapar el texto/heatmap.
  return `${hex}33`; // ~20% opacidad
}

/** Color sólido del estado (para leyenda / chips). '' si no hay. */
export function colorEstado(estado: string | null | undefined): string {
  if (!estado) return '';
  return COLOR_HEX[estado] ?? '';
}

/**
 * Color ARGB para Excel (exceljs). Fondo TENUE por defecto (mezcla con blanco
 * al ~20%, equivalente al `${hex}33` de la web), o sólido si `solido=true`
 * (para las filas de subtotal por estado). '' si no hay estado.
 */
export function colorArgbEstado(estado: string | null | undefined, solido = false): string {
  if (!estado) return '';
  const hex = COLOR_HEX[estado];
  if (!hex) return '';
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);
  if (solido) {
    const h = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
    return `FF${h(r)}${h(g)}${h(b)}`;
  }
  // Tenue: mezcla 20% color + 80% blanco (aprox. el alpha 0x33 sobre fondo blanco).
  const mezcla = (n: number) => Math.round(n * 0.2 + 255 * 0.8);
  const h = (n: number) => mezcla(n).toString(16).padStart(2, '0').toUpperCase();
  return `FF${h(r)}${h(g)}${h(b)}`;
}

/** Estados de venta conocidos, en orden de ciclo de vida (para la leyenda). */
export const ESTADOS_VENTA = ['Disponible', 'Reservado', 'Formalizado', 'Entregado'] as const;
